"use strict";

exports.__esModule = true;
exports["default"] = Search20;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Search20(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.5 1C7.4 1 4 4.4 4 8.5c0 1.8.6 3.4 1.7 4.7l-4.4 4.4c-.3.4-.3.8 0 1.1.3.3.8.3 1.1 0l4.5-4.4c1.3 1 2.9 1.6 4.7 1.6 4.1 0 7.5-3.4 7.5-7.5S15.6 1 11.5 1zm0 13C8.5 14 6 11.5 6 8.5S8.5 3 11.5 3 17 5.5 17 8.5 14.5 14 11.5 14z"
  }));
}